import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlertService } from './alert.service';
import { AuthService } from './auth.service';
import { EndpointFactoryService } from "./endpoint-factory.service";

@Injectable()
export class ProgramInfoEndpointService extends EndpointFactoryService {
    protected URL: string = "/api/ProgramInfo/";

    constructor(http: HttpClient, alertService: AlertService, authService: AuthService) {
        super(http, alertService, authService);
    }

    getVersion(): Observable<string> {
        return this.getAuthorizedWithErrorHandlingAndNoJsonResult<string>(this.URL + "Version", () => this.getVersion());
    }
}
